// AWS Amplify Configuration
// This file configures Cognito authentication

import { getAppleOAuthConfig } from './utils/authOrigin';

const configuredOAuth = getAppleOAuthConfig(window.location.hostname);
export const appleSignInEnabled = process.env.REACT_APP_APPLE_SIGN_IN_ENABLED === 'true' && Boolean(configuredOAuth);
const oauth = appleSignInEnabled ? configuredOAuth : undefined;

const awsconfig = {
  Auth: {
    Cognito: {
      region: process.env.REACT_APP_COGNITO_REGION || 'us-west-2',
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
      ...(oauth ? { loginWith: { oauth } } : {}),
    }
  }
};

export default awsconfig;
